import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  Form,
  Button,
  Spin,
  Col,
  Modal,
  Input,
} from 'antd';
// import { useSelector } from 'react-redux';
import { onError } from 'utils/handlers';
// import Select from 'components/Select';
import FormSubmitControls from 'components/FormSubmitControls';
import Table from 'components/Table';
import ModalDelete from 'components/ModalDelete';
import { getTiposDeDato } from 'api/configuracion';
import {
  deleteValorPorVariableDeSeleccion,
  getValoresPorVariablesDeSeleccion,
  patchValorPorVariableDeSeleccion,
  postValorPorVariableDeSeleccion,
  baseURI,
} from 'api/configuracion/valoresPorVariablesDeSeleccion';
import { uniqueValidator } from 'utils/rules';

export const permissionValorPorVariableDeSeleccion = {
  model: 'valorporvariabledeseleccion',
};

const ValoresParaVariablesDeSeleccion = ({ permission, variable }) => {
  // const estadosGlobales = useSelector(({ catalogs }) => catalogs.estadosGlobales);
  const [form] = Form.useForm();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(false);
  const [visibleAlert, setVisibleAlert] = useState(false);
  const [data, setData] = useState([]);

  const fetchData = async () => {
    setLoading(true);
    const _variables = await getValoresPorVariablesDeSeleccion({ variable });
    setData(_variables);
    setLoading(false);
  };

  useEffect(() => {
    let mounted = true;
    const fetch = async () => {
      setLoading(true);
      await getTiposDeDato();
      const _variables = await getValoresPorVariablesDeSeleccion();
      if (mounted) {
        setData(_variables);
        setLoading(false);
      }
    };
    fetch();
    return () => { mounted = false; };
  }, []);

  const onCancel = () => {
    form.resetFields();
    setVisible(false);
    setSelectedRowKeys([]);
  };

  const onFinish = async () => {
    try {
      setLoading(true);
      await form.validateFields();
      const values = form.getFieldsValue();
      values.variable = variable;
      const [key] = selectedRowKeys;
      const response = await (key ? patchValorPorVariableDeSeleccion(key, values)
        : postValorPorVariableDeSeleccion(values));
      if (response) {
        onCancel();
        await fetchData();
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const handleOnRowClick = (record) => {
    setSelectedRowKeys([record.id]);
    form.setFieldsValue(record);
  };

  const onClickAdd = () => {
    onCancel();
    setVisible(true);
  };

  const onClickDelete = () => setVisibleAlert(true);

  const onClickEdit = () => setVisible(true);

  const deleteItem = async () => {
    setLoading(true);
    const [key] = selectedRowKeys;
    const deleted = await deleteValorPorVariableDeSeleccion(key);
    if (deleted) {
      setVisibleAlert(false);
      onCancel();
      await fetchData();
    }
    setLoading(false);
  };

  const rowSelection = {
    selectedRowKeys,
    type: 'radio',
  };

  const rules = {
    valor: [
      { required: true },
      uniqueValidator(data, selectedRowKeys[0]),
    ],
  };

  const columns = [
    {
      titleText: 'Valor',
      key: 'valor',
      dataIndex: 'valor',
    },
  ];

  return (
    <>
      <Spin tip="Cargando..." spinning={loading}>
        <br />
        <Table
          cols={columns}
          data={data}
          rowSelection={rowSelection}
          handleOnRowClick={handleOnRowClick}
          controls={{
            onClickAdd,
            onClickDelete,
            onClickEdit,
          }}
          // noControls={disabled}
          allowSort={false}
          allowSearch={false}
          rowKey="id"
          baseURI={baseURI}
          allowImport
          permission={permission}
          hasAllViewPermission
          mobileColIndex={0}
        />
        <Modal
          visible={visible}
          closable={false}
          footer={null}
          title={(
            <FormSubmitControls
              label={`${selectedRowKeys.length ? 'Editar' : 'Agregar'} Valor`}
              onFinish={onFinish}
              onCancel={onCancel}
              loading={loading}
              permission={{ ...permission, import: true }}
            />
          )}
          keyboard={!loading}
          maskClosable={!loading}
          onCancel={onCancel}
          forceRender
        >
          <Col span={24}>
            <Form
              form={form}
              layout="vertical"
              onFinish={onFinish}
              initialValues={{ estados_globales: 1 }}
              name="valores_variables_seleccion"
            >
              <Col span={24}>
                <Form.Item
                  name="valor"
                  rules={rules.valor}
                  label="Valor"
                >
                  <Input allowClear />
                </Form.Item>
              </Col>
              <Form.Item name="id" hidden>
                <Input />
              </Form.Item>
              <Form.Item hidden>
                <Button htmlType="submit" />
              </Form.Item>
            </Form>
          </Col>
        </Modal>
      </Spin>
      <ModalDelete
        onDelete={deleteItem}
        onCancel={() => setVisibleAlert(false)}
        visible={visibleAlert}
        content="la variable"
      />
    </>
  );
};

ValoresParaVariablesDeSeleccion.propTypes = {
  permission: PropTypes.shape({
    add: PropTypes.bool.isRequired,
    authorize: PropTypes.bool.isRequired,
    cancel: PropTypes.bool.isRequired,
    change: PropTypes.bool.isRequired,
    delete: PropTypes.bool.isRequired,
    export: PropTypes.bool.isRequired,
    import: PropTypes.bool.isRequired,
    sync: PropTypes.bool.isRequired,
    view: PropTypes.bool.isRequired,
  }).isRequired,
  variable: PropTypes.number.isRequired,
};

export default ValoresParaVariablesDeSeleccion;
